import { render, staticRenderFns } from "./PbiTest.vue?vue&type=template&id=f5e08a0e&"
import script from "./PbiTest.vue?vue&type=script&lang=js&"
export * from "./PbiTest.vue?vue&type=script&lang=js&"
import style0 from "./PbiTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports